import { render, staticRenderFns } from "./VersionOverlay.vue?vue&type=template&id=90237c98&scoped=true"
import script from "./VersionOverlay.vue?vue&type=script&lang=js"
export * from "./VersionOverlay.vue?vue&type=script&lang=js"
import style0 from "./VersionOverlay.vue?vue&type=style&index=0&id=90237c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90237c98",
  null
  
)

export default component.exports